import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';

interface HookProps {
  date: Date;
}

export const useGenerateBatchesReport = () => {
  const toasterId = toast.info('Generating batches report..', {
    containerId: 'generateBatchesReport',
    autoClose: false,
    closeButton: false,
  });

  return useMutation({
    mutationFn: async ({ date }: HookProps) => {
      const { data, headers } = await request(
        {
          path: `declarations/generate-batches-report`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: {
            date,
          },
        },
        true,
      );
      const href = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      const reportFilename = headers['content-disposition']?.match(/filename="([^"]*)"/)[1] || 'intrastat-daily.zip';
      link.setAttribute('download', reportFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.update(toasterId, {
        render: 'Successfully generated the batches report!',
        autoClose: 3000,
        closeButton: true,
        type: 'success',
      });
    },
    onError: (error) => {
      toast.update(toasterId, {
        render: `Error generating the batches report!`,
        autoClose: 3000,
        closeButton: true,
        type: 'error',
      });
    },
  });
};
